/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Integration_Connect_UnavailableInputs */

const en_integration_connect_unavailable = /** @type {(inputs: Integration_Connect_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.provider} could not be reached. Please try again in a few minutes.`)
};

const es_integration_connect_unavailable = /** @type {(inputs: Integration_Connect_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo contactar con ${i?.provider}. Inténtalo de nuevo en unos minutos.`)
};

/**
* | output |
* | --- |
* | "{provider} could not be reached. Please try again in a few minutes." |
*
* @param {Integration_Connect_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_connect_unavailable = /** @type {((inputs: Integration_Connect_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Connect_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_connect_unavailable(inputs)
	return en_integration_connect_unavailable(inputs)
});